
import { Box, Button, Container, Grid, Stack, styled, Typography } from '@mui/material';
import ListBox from '@/app/components/listsBox/listBox';
import { getDictionary, getField } from '@/app/utils/translation/translation';



export default function MarketingPlatform({ isMobile, language, translations }: { isMobile: boolean, language: any, translations: any }) {
    const dictionary = getDictionary(translations, 'marketing', language);
    const data = [
        { title: getField(dictionary, 'list-title-one', language), subtitle: getField(dictionary, 'listitemone', language) },
        { title: getField(dictionary, 'list-title-two', language), subtitle: getField(dictionary, 'list-item-two', language) },
        { title: getField(dictionary, 'list-title-three', language), subtitle: getField(dictionary, 'list-item-three', language) },
        { title: getField(dictionary, 'list-title-four', language), subtitle: getField(dictionary, 'list-item-four', language) },
        { title: getField(dictionary, 'list-title-five', language), subtitle: getField(dictionary, 'list-item-five', language) },
        { title: getField(dictionary, 'list-title-six', language), subtitle: getField(dictionary, 'list-item-six', language) },
        { title: getField(dictionary, 'list-title-sev', language), subtitle: getField(dictionary, 'list-item-sev', language) },
        { title: getField(dictionary, 'list-title-eight', language), subtitle: getField(dictionary, 'list-item-eight', language) },
    ];
    const PurpleBackground = styled(Box)({
        backgroundColor: 'var(--section-bg-hover)',
        height: '340px',
        display: 'flex',
        // width: isMobile ? '50%' : '70vw',
        padding: '1rem 2rem',
        borderTopLeftRadius: '30px',
        borderBottomLeftRadius: '30px',
        position: 'relative'
    });
    const isArabic = language === 'arabic';

    return (
        <>
            <div style={{ display: 'grid', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ textAlign: 'center', marginBottom: '1rem', fontSize: isMobile ? '17px' : '25px', letterSpacing: isArabic ? ' ' :'1px', fontWeight: 'bold' }}>
                    <Typography variant={"h5"} fontWeight={"bold"} fontFamily={"Century Gothic"} color="var(--accent-primary)">
                        {isArabic ? (
                            <>
                                <span style={{ color: 'var(--accent-secondary)' }}>!</span>
                                {getField(dictionary, 'your', language)}

                            </>) :
                            (<>
                                {getField(dictionary, 'your', language)}
                                <span style={{ color: 'var(--accent-secondary)' }}>!</span>
                            </>)}
                    </Typography>

                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '4rem' }}>
                    <Button variant='contained' sx={{ backgroundColor: 'var(--accent-secondary)', color: 'black' }}>
                        {getField(dictionary, 'get-free-demo', language)}
                    </Button>
                </div>

            </div>
            {isMobile ? (<>
                <div style={{ display: 'flex', flexDirection: "column", backgroundColor: "var(--section-bg-hover)", padding: "10px", borderTopLeftRadius: "30px", borderTopRightRadius: "30px" }}>
                    <div><Typography fontFamily="Century Gothic" textAlign={isArabic ? "right" : "left"} fontWeight={"bold"} sx={{ color: "var(--text-primary)", fontSize: "1.3rem"}}>{getField(dictionary, 'powerfull', language)}<br /> {getField(dictionary, 'easy-to-use-tools', language)}</Typography> </div>
                    <Box sx={{ 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        // transform: "translate(-0.6rem, 2rem)",
                        width: "100%",
                        // maxWidth: "400px"
                        }}>
                        <img 
                            src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/tools.png`} 
                            loading="lazy" 
                            style={{ 
                            width: "100%", 
                            height: "auto", 
                            maxWidth: "400px"
                            }} 
                            alt='tools' 
                        />
                    </Box>
                    <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'center', width: '100%', transform: isMobile ? "translateY(0.5rem)" : "translateY(-18rem)" }}>
                        <Grid container spacing={0} sx={{ maxWidth: isMobile ? '1200px' : '900px', justifyContent: 'center' }}>
                            {data.map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center', padding: 0 }} key={index} >
                                    <ListBox key={index} title={item.title} subtitle={item.subtitle} isMobile={isMobile} language={language} />
                                </Grid>
                            ))}
                        </Grid>
                    </Container>


                </div>
            </>)
                :
                (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <PurpleBackground>
                                <div style={{ display: 'flex', flexDirection: "column" }}>
                                    <Typography fontFamily="Century Gothic" variant='h5' textAlign={isArabic ? "right" : "left"} fontWeight={"bold"} sx={{ color: "var(--text-primary)" }}>{getField(dictionary, 'powerfull', language)}<br /> {getField(dictionary, 'easy-to-use-tools', language)}</Typography>
                                    <Box 
                                    // sx={{ transform: "translate(0rem, 2rem)", width: "100%"
                                    
                                    //  }}
                                     >
                                        <img 
                                            src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/tools.png`} 
                                            loading="lazy" 
                                            style={{ 
                                                width: "50%", 
                                                height: "auto", 
                                                // maxWidth: "300px"
                                            }} 
                                            alt='tools' 
                                        />
                                    </Box>
                                </div>

                        <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', transform: isMobile ? "translateY(2rem)" : "unset", position: isMobile ? "relative" : 'absolute', top: '2rem', right: '0.5rem'}}>
                            <Stack spacing={2} alignItems={isMobile ? "center" : "flex-end"}>
                                {data.map((item, index) => (
                                    <ListBox key={index} title={item.title} subtitle={item.subtitle} isMobile={isMobile} language={language} />
                                ))}
                            </Stack>
                        </Container>
                            </PurpleBackground>
                        </div>
                       
                    </>
                )}


        </>
    );
}
